const BreakPoints = {
    xxl: 1400,
    xl: 1200,
    lg: 992,
    md: 768,
    sm: 576,
    xs: 0
};

export const BreakPointIdentifier = {
    [BreakPoints.xxl]: "xxl-",
    [BreakPoints.xl]: "xl-",
    [BreakPoints.lg]: "lg-",
    [BreakPoints.md]: "md-",
    [BreakPoints.sm]: "sm-",
    [BreakPoints.xs]: ""
};

export default BreakPoints;
